// noinspection MagicNumberJS

document.addEventListener( 'DOMContentLoaded', () => {
	class JTFCAROUSEL {

		static MOBILE_REDUCTION_NUMBER = 0.8
		static BREAKPOINT_TABLET = 768
		static BREAKPOINT_MOBILE = 576
		static KEYCODE_LEFT_ARROW = 37
		static KEYCODE_RIGHT_ARROW = 39
		static TIMER_POINT_THREE_SECONDS = 300
		static TIMER_THREE_SECONDS = 3000
		static TIMER_FIVE_SECONDS = 5000
		static CLASS_NAME_DOT_ACTIVE = 'jtf__carouselblock--dot-active'
		static SELECTOR_CLASS_DOT_ACTIVE = '.jtf__carouselblock--dot-active'
		static SELECTOR_CLASS_PLAY_PAUSE_BUTTON = '.jtf__carouselblock--play_pause_control button'
		static SELECTOR_CLASS_PREV = '.jtf__carouselblock--prev'
		static SELECTOR_CLASS_CONTAINER = '.jtf__carouselblock--container'
		static SELECTOR_CLASS_DOT = '.jtf__carouselblock--dot'
		static SELECTOR_CLASS_NAV = '.jtf__carouselblock--navigation'
		static SELECTOR_CLASS_NEXT = '.jtf__carouselblock--next'
		static SELECTOR_CLASS_PANEL_IMAGE = '.jtf__carouselblock--cell-image img'
		static SELECTOR_CLASS_INNER = '.jtf__carouselblock--inner'
		static SELECTOR_CLASS_TIMELINE = '.jtf__carouselblock--timeline'
		static SELECTOR_CLASS_ITEM = '.jtf__carouselblock--item'
		static SELECTOR_CLASS_IMAGE_NO_CROP = '.jtf__carouselblock--cell-image-no-crop'
		static SELECTOR_CLASS_STATIC_BG = '.jtf__carouselblock--staticbg'
		static SELECTOR_CLASS_TRANS_BG = '.jtf__carouselblock--transbg'
		static SELECTOR_CLASS_PLAY_PAUSE_CONTROL = '.jtf__carouselblock--play_pause_control'
		static SELECTOR_CLASS_DOTS = '.jtf__carouselblock--dots'
		static SELECTOR_CLASS_NAV_CONTAINER = '.jtf__carouselblock--nav'
		static ATTR_DATA_CHILDREN = 'data-children'
		static ATTR_DATA_MOBILEREDUCTION = 'data-mobilereduction'
		static ATTR_DATA_AUTOSLIDE = 'data-autoslide'
		static ATTR_DATA_AUTOSLIDEDELAY = 'data-autoslidedelay'
		static ATTR_DATA_SLIDESBGIMAGES = 'data-slidesbgimages'
		static ATTR_DATA_ARROWSTYLE = 'data-arrowstyle'
		static ATTR_DATA_STATE = 'data-state'
		static ATTR_DATA_TARGET = 'data-target'
		static ATTR_DATA_ID = 'data-id'
		static ATTR_ARIA_HIDDEN = 'aria-hidden'
		static ATTR_ARIA_SELECTED = 'aria-selected'
		static ATTR_ARIA_CONTROLS = 'aria-controls'
		static ATTR_ARIA_LABEL = 'aria-label'
		static ATTR_ARIA_LIVE = 'aria-live'
		static PROP_STATE_ENABLED = 'enabled'
		static PROP_STATE_DISABLED = 'disabled'
		static PROP_ARROW_STYLE_DEFAULT = 'defaultArrow'
		static PROP_ARROW_STYLE_DEFAULT_ICON = 'fa-angle-'
		static PROP_ARROW_STYLE_CIRCLE_ICON = 'fa-circle-chevron-'

		// noinspection FunctionWithMoreThanThreeNegationsJS
		constructor( context, wpAdmin ) {
			this.context = context
			this.carouselInner = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_INNER )
			this.carouselContainer = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_CONTAINER )
			this.carouselNav = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_NAV_CONTAINER )

			// If any required element is missing, retry after a short delay
			// ensures all carousels on a page load properly in WP Admin
			if ( !this.context || !this.carouselContainer || !this.carouselNav ) {
				setTimeout( () => {
					new JTFCAROUSEL( this.context, wpAdmin )
				}, 300 )
				return
			}

			this.carouselInnerChildren = this.carouselInner.getAttribute( JTFCAROUSEL.ATTR_DATA_CHILDREN )
			this.timelinePanelCount = 1
			this.carouselContainerWidth = this.context.offsetWidth
			this.timeline = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_TIMELINE )
			this.isMobile = window.innerWidth < JTFCAROUSEL.BREAKPOINT_MOBILE
			this.individualPanel = this.context.querySelectorAll( JTFCAROUSEL.SELECTOR_CLASS_ITEM )
			this.imageNoCrop = this.context.querySelectorAll( JTFCAROUSEL.SELECTOR_CLASS_IMAGE_NO_CROP )
			this.staticBackground = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_STATIC_BG )
			this.tempBackground = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_TRANS_BG )
			this.wpAdmin = wpAdmin
			this.playPauseControl = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_PLAY_PAUSE_CONTROL )
			this.carouselDots = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_DOTS )

			this.interval = null
			this.mobileReduction = !!this.context.getAttribute( JTFCAROUSEL.ATTR_DATA_MOBILEREDUCTION ) || false
			this.autoSlide = this.carouselContainer.getAttribute( JTFCAROUSEL.ATTR_DATA_AUTOSLIDE ) || 'noneset'
			this.autoSlideDelay = this.carouselContainer.getAttribute( JTFCAROUSEL.ATTR_DATA_AUTOSLIDEDELAY ) * 1000 || 5000
			this.currentPosition = 0
			this.imageMaxHeight = 0
			this.backgroundImages = this.context.getAttribute( JTFCAROUSEL.ATTR_DATA_SLIDESBGIMAGES )
			this.containerStyle = this.carouselContainer.getAttribute( 'style' ) || ''
			this.arrowStyle = this.carouselNav.getAttribute( JTFCAROUSEL.ATTR_DATA_ARROWSTYLE ) === JTFCAROUSEL.PROP_ARROW_STYLE_DEFAULT ? JTFCAROUSEL.PROP_ARROW_STYLE_DEFAULT_ICON : JTFCAROUSEL.PROP_ARROW_STYLE_CIRCLE_ICON

			this.playIcon = '<i class="fa-solid fa-play"></i>'
			this.pauseIcon = '<i class="fa-solid fa-pause"></i>'
			this.playPauseButton = `<button type="button" href="javascript:void(0);" aria-controls="carouselblock--items" aria-label="Stop automatic slide show" ${ JTFCAROUSEL.ATTR_DATA_STATE }="${ JTFCAROUSEL.PROP_STATE_ENABLED }" ><i class="fa-solid fa-pause"></i></button>`
			this.previousButton = `<button type="button" class="jtf__carouselblock--prev jtf__carouselblock--navigation" style="${ this.containerStyle }" href="javascript:void(0);" aria-controls="carouselblock--items" aria-label="previous slide" ><i class="far ${ this.arrowStyle }left" ></i></button>`
			this.nextButton = `<button type="button" class="jtf__carouselblock--next jtf__carouselblock--navigation" href="javascript:void(0);" style="${ this.containerStyle }" aria-controls="carouselblock--items" aria-label="next slide " ><i class="far ${ this.arrowStyle }right" ></i></button>`

			this.startAutomatic = 'Stop automatic slide show'
			this.stopAutomatic = 'Start automatic slide show'

			this.reboot()
			this.carouselDot = this.context.querySelectorAll( JTFCAROUSEL.SELECTOR_CLASS_DOT )
			this.loadCarousel()
		}

		navigateCarousel() {
			let transformValue
			if ( this.timeline ) {
				const timelinePanelWidth = this.carouselContainerWidth / this.timelinePanelCount
				transformValue = -(this.currentPosition * (this.isMobile ? this.carouselContainerWidth : timelinePanelWidth) * this.canvasMobileWidth())
			} else {
				transformValue = -(this.currentPosition * this.carouselContainerWidth * this.canvasMobileWidth())
			}

			this.carouselInner.style.transform = `translateX(${ transformValue }px)`
			this.carouselInner.style.transitionDuration = '1s'
		}

		canvasMobileWidth() {
			return this.isMobile && this.mobileReduction ? JTFCAROUSEL.MOBILE_REDUCTION_NUMBER : 1
		}

		// noinspection FunctionWithMultipleLoopsJS
		setMaxImageHeight() {
			if ( this.imageNoCrop.length > 0 ) {
				const cssPanelImageEl = this.context.querySelectorAll( JTFCAROUSEL.SELECTOR_CLASS_PANEL_IMAGE )
				cssPanelImageEl.forEach( ( img ) => {
					img.style.visibility = 'hidden'
				} )

				cssPanelImageEl.forEach( ( img ) => {
					if ( img.complete ) {
						this.setMaxHeight( img )
					} else {
						img.addEventListener( 'load', () => {
							setTimeout( () => {
								this.setMaxHeight( img )
							}, JTFCAROUSEL.TIMER_POINT_THREE_SECONDS )
						} )
					}
				} )

				cssPanelImageEl.forEach( ( img ) => {
					if ( img.complete ) {
						this.setPanelImageCss( img )
					} else {
						img.addEventListener( 'load', () => {
							setTimeout( () => {
								this.setPanelImageCss( img, true )
							}, JTFCAROUSEL.TIMER_POINT_THREE_SECONDS )
						} )
					}
				} )
			}
		}

		setMaxHeight( img ) {
			const imgHeight = img.offsetHeight

			if ( imgHeight && parseInt( imgHeight ) > this.imageMaxHeight ) {
				this.imageMaxHeight = parseInt( imgHeight )
			}
		}

		setPanelImageCss( img, uncached = false ) {
			img.style.height = this.imageMaxHeight + 'px'
			img.style.objectFit = "contain"
			img.style.marginBottom = '1rem'
			img.style.visibility = 'visible'

			if ( uncached ) {
				img.style.opacity = '0'
				this.fadeIn( img, JTFCAROUSEL.TIMER_POINT_THREE_SECONDS )
			}
		}

		fadeIn( element, duration ) {
			element.style.opacity = '0'
			element.style.transition = `opacity ${ duration }ms`
			setTimeout( () => {
				element.style.opacity = '1'
			}, 10 )
		}

		fadeOut( element ) {
			element.style.transition = 'opacity 400ms'
			element.style.opacity = '0'
			setTimeout( () => {
				element.style.display = 'none'
			}, 400 )
		}

		changeBackgroundImage() {
			if ( JTFCAROUSEL.PROP_STATE_ENABLED === this.backgroundImages ) {
				let targetBackgroundImage = ''
				let currentBackgroundImage = ''

				this.individualPanel.forEach( ( panel ) => {
					const dataId = parseInt( panel.getAttribute( JTFCAROUSEL.ATTR_DATA_ID ) )
					const imgEl = panel.querySelector( JTFCAROUSEL.SELECTOR_CLASS_PANEL_IMAGE )
					const imgSrc = imgEl ? imgEl.getAttribute( 'src' ) : ''

					if ( parseInt( this.currentPosition ) === dataId ) {
						currentBackgroundImage = imgSrc
						targetBackgroundImage = imgSrc
					}
				} )

				if ( this.tempBackground ) {
					this.tempBackground.style.backgroundImage = `url(${ currentBackgroundImage })`
				}
				if ( this.staticBackground ) {
					this.staticBackground.style.backgroundImage = `url(${ targetBackgroundImage })`
				}

				if ( this.tempBackground ) {
					this.tempBackground.style.display = 'block'
				}
				if ( this.staticBackground ) {
					this.staticBackground.style.display = 'block'
				}
				if ( this.tempBackground ) {
					this.fadeOut( this.tempBackground )
				}
			}
		}

		// noinspection FunctionWithMultipleLoopsJS
		changeAriaDisplayStates() {
			this.individualPanel.forEach( ( panel ) => {
				const isHidden = parseInt( this.currentPosition ) === parseInt( panel.getAttribute( JTFCAROUSEL.ATTR_DATA_ID ) ) ? 'false' : 'true'
				panel.setAttribute( JTFCAROUSEL.ATTR_ARIA_HIDDEN, isHidden )

				// Set tabindex for buttons and anchor elements
				const buttons = panel.querySelectorAll( 'button, a[role="button"], a' )
				buttons.forEach( ( el ) => {
					if ( isHidden === 'true' ) {
						el.setAttribute( 'tabindex', '-1' )
					} else {
						el.removeAttribute( 'tabindex' )
					}
				} )
			} )
		}

		setActiveDot() {
			if ( this.carouselDot ) {
				const activeDotEl = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_DOT_ACTIVE )
				if ( activeDotEl ) {
					activeDotEl.classList.remove( JTFCAROUSEL.CLASS_NAME_DOT_ACTIVE )
				}

				this.carouselDot.forEach( ( dot ) => {
					const isActive = parseInt( dot.getAttribute( JTFCAROUSEL.ATTR_DATA_TARGET ) ) === parseInt( this.currentPosition )
					if ( isActive ) {
						dot.classList.add( JTFCAROUSEL.CLASS_NAME_DOT_ACTIVE )
					}
					dot.setAttribute( JTFCAROUSEL.ATTR_ARIA_SELECTED, isActive ? 'true' : 'false' )
				} )
			}
		}

		moveToNextSlide() {
			const calcNewPosition = parseInt( this.currentPosition ) + 1

			if ( calcNewPosition < parseInt( this.carouselInnerChildren ) ) {
				this.currentPosition = parseInt( calcNewPosition )
			} else {
				this.currentPosition = 0
			}

			this.changeBackgroundImage()
			this.changeAriaDisplayStates()
			this.setActiveDot()
			this.navigateCarousel()
		}

		moveToPrevSlide() {
			this.carouselContainer.setAttribute( 'data-max', 'false' )
			const calcNewPosition = parseInt( this.currentPosition ) - 1

			if ( this.currentPosition > 0 ) {
				this.currentPosition = parseInt( calcNewPosition )
			} else {
				this.currentPosition = parseInt( this.carouselInnerChildren ) - 1
			}

			this.changeBackgroundImage()
			this.changeAriaDisplayStates()
			this.setActiveDot()
			this.navigateCarousel()
		}

		autoSlideCarousel() {
			this.currentPosition = parseInt( this.currentPosition ) < parseInt( this.carouselInnerChildren ) - 1 ? parseInt( this.currentPosition ) + 1 : 0

			this.changeBackgroundImage()
			this.changeAriaDisplayStates()
			this.setActiveDot()
			this.navigateCarousel()
		}

		loadCarousel() {
			this.changeBackgroundImage( this.currentPosition )
			this.changeAriaDisplayStates( this.currentPosition )

			if ( JTFCAROUSEL.PROP_STATE_ENABLED === this.autoSlide ) {
				if ( this.wpAdmin.length === 0 ) {
					this.interval = setInterval( () => {
						this.autoSlideCarousel()
					}, this.autoSlideDelay )

					this.context.addEventListener( 'click', ( e ) => {
						const pauseButton = e.target.closest( JTFCAROUSEL.SELECTOR_CLASS_PLAY_PAUSE_BUTTON )
						if ( pauseButton ) {
							e.stopPropagation()

							if ( JTFCAROUSEL.PROP_STATE_ENABLED === pauseButton.getAttribute( JTFCAROUSEL.ATTR_DATA_STATE ) ) {
								clearInterval( this.interval )
								this.interval = null
								pauseButton.setAttribute( JTFCAROUSEL.ATTR_DATA_STATE, JTFCAROUSEL.PROP_STATE_DISABLED )
								pauseButton.setAttribute( JTFCAROUSEL.ATTR_ARIA_LABEL, this.startAutomatic )
								pauseButton.innerHTML = this.playIcon
								this.carouselInner.setAttribute( JTFCAROUSEL.ATTR_ARIA_LIVE, 'polite' )
							} else {
								this.interval = setInterval( () => {
									this.autoSlideCarousel()
								}, this.autoSlideDelay )
								pauseButton.setAttribute( JTFCAROUSEL.ATTR_DATA_STATE, JTFCAROUSEL.PROP_STATE_ENABLED )
								pauseButton.setAttribute( JTFCAROUSEL.ATTR_ARIA_LABEL, this.stopAutomatic )
								pauseButton.innerHTML = this.pauseIcon
								this.carouselInner.setAttribute( JTFCAROUSEL.ATTR_ARIA_LIVE, 'off' )
							}
						}
					} )

					const mouseEnterHandler = ( e ) => {
						e.stopPropagation()
						clearInterval( this.interval )
						this.interval = null

						const pauseButton = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_PLAY_PAUSE_BUTTON )
						if ( pauseButton ) {
							pauseButton.setAttribute( JTFCAROUSEL.ATTR_DATA_STATE, JTFCAROUSEL.PROP_STATE_DISABLED )
							pauseButton.setAttribute( JTFCAROUSEL.ATTR_ARIA_LABEL, this.startAutomatic )
							pauseButton.innerHTML = this.playIcon
						}
						this.carouselInner.setAttribute( JTFCAROUSEL.ATTR_ARIA_LIVE, 'polite' )
						this.context.removeEventListener( 'mouseenter', mouseEnterHandler )
					}

					this.context.addEventListener( 'mouseenter', mouseEnterHandler, { once: true } )
				}


				// Delay the initial auto-slide until DOM is fully ready
				setTimeout( () => {
					this.autoSlideCarousel()
				}, 300 )
			}

			this.context.addEventListener( 'click', ( e ) => {
				const prevButton = e.target.closest( JTFCAROUSEL.SELECTOR_CLASS_PREV )
				if ( prevButton ) {
					e.stopPropagation()
					this.moveToPrevSlide()
				}
			} )

			const carouselContainer = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_CONTAINER )
			if ( carouselContainer ) {
				carouselContainer.addEventListener( 'swiperight', () => {
					this.moveToPrevSlide()
				} )
			}

			this.context.addEventListener( 'keyup', ( e ) => {
				if ( e.which === JTFCAROUSEL.KEYCODE_LEFT_ARROW ) {
					this.moveToPrevSlide()
				}
			} )

			this.context.addEventListener( 'click', ( e ) => {
				const nextButton = e.target.closest( JTFCAROUSEL.SELECTOR_CLASS_NEXT )
				if ( nextButton ) {
					e.stopPropagation()
					this.moveToNextSlide()
				}
			} )

			const containerElement = this.context.querySelector( JTFCAROUSEL.SELECTOR_CLASS_CONTAINER )
			if ( containerElement ) {
				containerElement.addEventListener( 'swipeleft', () => {
					this.moveToNextSlide()
				} )
			}

			this.context.addEventListener( 'keyup', ( e ) => {
				if ( e.which === JTFCAROUSEL.KEYCODE_RIGHT_ARROW ) {
					this.moveToNextSlide()
				}
			} )

			this.context.addEventListener( 'click', ( e ) => {
				const dotButton = e.target.closest( JTFCAROUSEL.SELECTOR_CLASS_DOT )
				if ( dotButton ) {
					const position = dotButton.getAttribute( JTFCAROUSEL.ATTR_DATA_TARGET )

					if ( parseInt( this.currentPosition ) !== parseInt( position ) ) {
						this.changeBackgroundImage( parseInt( position ), this.currentPosition )
						this.changeAriaDisplayStates( parseInt( position ) )
					}

					this.currentPosition = parseInt( position )
					this.setActiveDot()
					this.navigateCarousel()
				}
			} )
		}

		generateNavigation( slideCount ) {
			// Check if navigation dots are enabled and present
			if ( !this.carouselDots ) {
				this.removeNavigation()
				return
			}

			this.carouselNav.innerHTML = this.carouselDots.outerHTML
			this.carouselDots = this.carouselNav.querySelector( JTFCAROUSEL.SELECTOR_CLASS_DOTS )
			if ( !this.carouselDots ) {
				this.removeNavigation()
				return
			}

			this.carouselDots.insertAdjacentHTML( 'beforebegin', this.previousButton )

			// Only update playPauseControl if it exists
			if ( this.autoSlide === JTFCAROUSEL.PROP_STATE_ENABLED ) {
				this.playPauseControl.innerHTML = ''
				this.playPauseControl.insertAdjacentHTML( 'beforeend', this.playPauseButton )
				this.carouselDots.insertAdjacentElement( 'beforebegin', this.playPauseControl )
			}

			if ( this.carouselDots ) {
				this.carouselDots.innerHTML = ''
				for ( let x = 0; x < slideCount; x++ ) {
					let activeClass = x === 0 ? JTFCAROUSEL.CLASS_NAME_DOT_ACTIVE : ''
					let ariaSelect = x === 0 ? 'true' : 'false'
					this.carouselDots.insertAdjacentHTML( 'beforeend', `<button type="button" class="jtf__carouselblock--dot ${ activeClass }" ${ JTFCAROUSEL.ATTR_ARIA_SELECTED }="${ ariaSelect }" ${ JTFCAROUSEL.ATTR_DATA_TARGET }="${ x }" style="${ this.containerStyle }" role="tab" ${ JTFCAROUSEL.ATTR_ARIA_LABEL }="Slide ${ x + 1 }" ${ JTFCAROUSEL.ATTR_ARIA_CONTROLS }="carouselblock--item--${ x + 1 }"><i class="fas fa-circle"></i></button>` )
				}
			}

			this.carouselDots.insertAdjacentHTML( 'afterend', this.nextButton )
		}

		removeNavigation() {
			const container = document.querySelector( JTFCAROUSEL.SELECTOR_CLASS_NAV_CONTAINER )
			if ( container ) {
				container.innerHTML = ''
			}
		}

		reboot() {
			this.currentPosition = 0
			let itemWidth = this.carouselContainerWidth * this.canvasMobileWidth()

			if ( this.timeline ) {
				this.timelinePanelCount = 4

				if ( this.individualPanel.length < 4 ) {
					this.timelinePanelCount = this.individualPanel.length
				}

				this.timelinePanelCount = window.innerWidth < JTFCAROUSEL.BREAKPOINT_TABLET ? 2 : this.timelinePanelCount
				this.timelinePanelCount = window.innerWidth < JTFCAROUSEL.BREAKPOINT_MOBILE ? 1 : this.timelinePanelCount
				this.carouselInner.setAttribute( JTFCAROUSEL.ATTR_DATA_CHILDREN, this.timelinePanelCount )

				itemWidth = (this.carouselContainerWidth / this.timelinePanelCount) * this.canvasMobileWidth()
			}

			this.carouselInner.style.transform = 'translateX(0)'
			const panelCss = {
				width: itemWidth + 'px',
				display: 'inline-flex',
			}

			if ( this.wpAdmin.length > 0 ) {
				setTimeout( () => {
					if ( this.carouselInnerChildren > 1 || this.timeline ) {
						this.generateNavigation( this.carouselInnerChildren, this.context )
					} else {
						this.removeNavigation()
					}
					this.individualPanel.forEach( ( panel ) => {
						panel.style.width = panelCss.width
						panel.style.display = panelCss.display
					} )
					this.setMaxImageHeight()
				}, JTFCAROUSEL.TIMER_POINT_THREE_SECONDS )
			} else {
				if ( this.carouselInnerChildren > 1 || this.timeline ) {
					this.generateNavigation( this.carouselInnerChildren )
				} else {
					this.removeNavigation()
				}
				this.individualPanel.forEach( ( panel ) => {
					panel.style.width = panelCss.width
					panel.style.display = panelCss.display
				} )
				this.setMaxImageHeight()
			}
		}
	}

	const wpAdmin = document.querySelectorAll( '.wp-admin' )
	if ( wpAdmin.length > 0 ) {
		let jtfCarouselAdmin = {}

		setTimeout( () => {
			const blockContainerElement = document.querySelectorAll( '.wp-block-jtf-jtf-carousel' )
			if ( blockContainerElement.length > 0 ) {
				blockContainerElement.forEach( ( block ) => {
					jtfCarouselAdmin = new JTFCAROUSEL( block, wpAdmin )
				} )

				document.addEventListener( 'click', ( e ) => {
					const reloadButton = e.target.closest( '.jtf__carouselblock--panelbuttons-reload' )
					if ( reloadButton ) {
						setTimeout( () => {
							blockContainerElement.forEach( ( block ) => {
								jtfCarouselAdmin = new JTFCAROUSEL( block, wpAdmin )
							} )
						}, JTFCAROUSEL.TIMER_THREE_SECONDS )
					}
				} )
			}
		}, JTFCAROUSEL.TIMER_FIVE_SECONDS )
	} else {
		const blockContainerElement = document.querySelectorAll( '.wp-block-jtf-jtf-carousel' )
		if ( blockContainerElement.length > 0 ) {
			blockContainerElement.forEach( ( block ) => {
				new JTFCAROUSEL( block, wpAdmin )
			} )
		}
	}
} )